import React from 'react';
import { BdsTypo, BdsIcon, BdsInputEditable } from 'blip-ds/dist/blip-ds-react';
import {
  BreadcrumbContainer,
  BreadcrumbItem as BreadcrumbItemContainer,
  BreadcrumbLink,
  BreadcrumbSeparator,
} from './styles';
import { BreadcrumbItem } from '../../hooks/useBreadcrumb';

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  lastItemEditable?: boolean;
  onEditLastItem?: (newValue: string) => void;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, lastItemEditable = false, onEditLastItem }) => {
  if (!items || items.length === 0) {
    return null;
  }

  const handleLastItemSave = (event: CustomEvent) => {
    if (onEditLastItem) {
      onEditLastItem(event.detail.value);
    }
  };

  const renderBreadcrumbItem = (item: BreadcrumbItem, isLast: boolean) => {
    if (isLast) {
      if (lastItemEditable) {
        return (
          <BdsInputEditable
            value={typeof item.label === 'string' ? item.label : ''}
            onBdsInputEditableSave={handleLastItemSave}
          />
        );
      }
      return (
        <BdsTypo variant="fs-20" bold="bold" margin={false}>
          {item.label}
        </BdsTypo>
      );
    }

    if (item.path) {
      return (
        <BreadcrumbLink to={item.path} style={{ textDecoration: 'none' }}>
          <BdsTypo variant="fs-20" margin={false}>
            {item.label}
          </BdsTypo>
        </BreadcrumbLink>
      );
    }

    return (
      <BdsTypo variant="fs-20" margin={false}>
        {item.label}
      </BdsTypo>
    );
  };

  return (
    <BreadcrumbContainer>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const key = item.path || `${item.label}-${index}`;

        return (
          <React.Fragment key={key}>
            <BreadcrumbItemContainer>{renderBreadcrumbItem(item, isLast)}</BreadcrumbItemContainer>

            {!isLast && (
              <BreadcrumbSeparator>
                <BdsIcon name="arrow-right" size="large" />
              </BreadcrumbSeparator>
            )}
          </React.Fragment>
        );
      })}
    </BreadcrumbContainer>
  );
};

export default Breadcrumb;
